import classNames from 'classnames'
import { FaqMinusIcon } from 'src/components/Icons/FaqMinusIcon'
import { FaqPlusIcon } from 'src/components/Icons/FaqPlusIcon'
import type { SeoContentAndFaqTheme } from 'src/types/seoContentAndFaq2'

interface FaqAccordionItem20Props {
  index: number
  question: string
  answer: string
  theme: SeoContentAndFaqTheme
  isOpen: boolean
  onToggle: () => void
}

const THEME_STYLES = {
  light: {
    question: 'text-fullDark',
    answer: 'text-fullDark',
    iconColor: '#101010',
  },
  dark: {
    question: 'text-white',
    answer: 'text-tertiary [&_a]:text-white [&_u]:text-white',
    iconColor: '#FFFFFF',
  },
} as const

export default function FaqAccordionItem20({
  index,
  question,
  answer,
  theme,
  isOpen,
  onToggle,
}: FaqAccordionItem20Props) {
  const styles = THEME_STYLES[theme]

  return (
    <li className="border-b border-insurance">
      <button
        type="button"
        aria-expanded={isOpen}
        aria-controls={`seo-editorial-faq-answer-${index}`}
        className="flex w-full items-center justify-between py-5 md:py-10 text-left"
        onClick={onToggle}
      >
        <span
          className={classNames(
            'text-base md:text-[26px] font-semibold',
            styles.question
          )}
        >
          {question}
        </span>

        <span className="ml-2 shrink-0">
          {isOpen ? (
            <FaqMinusIcon color={styles.iconColor} width={24} height={24} />
          ) : (
            <FaqPlusIcon color={styles.iconColor} width={24} height={24} />
          )}
        </span>
      </button>

      <div
        id={`seo-editorial-faq-answer-${index}`}
        data-testid={`seo-editorial-faq-answer-${index}`}
        aria-hidden={!isOpen}
        className={classNames(
          'overflow-hidden transition-[max-height,padding,opacity] duration-200 ease-out',
          isOpen ? 'max-h-none pb-4 opacity-100' : 'max-h-0 pb-0 opacity-0'
        )}
      >
        <div
          className={classNames('text-sm', styles.answer)}
          dangerouslySetInnerHTML={{
            __html: answer,
          }}
        />
      </div>
    </li>
  )
}
